import { render, staticRenderFns } from "./NumberItem.vue?vue&type=template&id=0fec44b5&scoped=true&lang=pug&"
import script from "./NumberItem.vue?vue&type=script&lang=ts&"
export * from "./NumberItem.vue?vue&type=script&lang=ts&"
import style0 from "./NumberItem.vue?vue&type=style&index=0&id=0fec44b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fec44b5",
  null
  
)

export default component.exports